import { render, staticRenderFns } from "./ShopComponent.vue?vue&type=template&id=594a5cc7&"
import script from "./ShopComponent.vue?vue&type=script&lang=js&"
export * from "./ShopComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports